exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Cabin:400,500,600,700);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!../fonts/fontawesome/css/all.css"), "");

// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/assets/styles/fonts.scss
// module id = 866
// module chunks = 0